function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { modes } from "../../utils";
// import styles from "./styles.css";
import DiIconClose from "../icons/di-icon-close";
import DiIconSwitch from "../icons/di-icon-switch";
import DiIconCached from "../icons/di-icon-cached";
import DiIconDone from "../icons/di-icon-done";
import DiIconTick from "../icons/di-icon-tick";
import DiIconClear from "../icons/di-icon-clear";
import DiIconCamera from "../icons/di-icon-camera";
import DiButton from "../icons/di-button";
import DiIcon from "../icons/di-icon";
import DiIconbackArrow from "../icons/di-icon-backarrow";
import { snap } from '../di-makeup-engine/init';

var DiViewerMenuBar = function (_Component) {
  _inherits(DiViewerMenuBar, _Component);

  function DiViewerMenuBar(props) {
    _classCallCheck(this, DiViewerMenuBar);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {};
    return _this;
  }

  DiViewerMenuBar.prototype.render = function render() {
    var _this2 = this;

    var menuButtonsBottom = this.props.bottomMenuHeight ? this.props.bottomMenuHeight + 10 + 'px' : '10px';
    return React.createElement(
      "div",
      null,
      this.props.mode == modes.menuShowing && !this.props.cameraDenied && React.createElement(
        "div",
        { className: "bar orange" },
        React.createElement(
          "div",
          { className: "parts left w50" },
          React.createElement(DiIcon, {
            className: "arrow white small",
            onClick: function onClick() {
              return _this2.props.callback({ mode: _this2.props.visibleMode, setBefore: true });
            },
            icon: React.createElement(DiIconbackArrow, null) })
        ),
        React.createElement(
          "div",
          { className: "parts right w50" },
          React.createElement(
            "div",
            { className: "headerwhite" },
            "Choose Try-On Mode"
          )
        )
      ),
      this.props.mode == modes.takingPhoto && React.createElement(
        "div",
        { className: "bar transparent" },
        React.createElement(
          "div",
          { className: "left parts" },
          React.createElement(DiIcon, {
            className: "arrow black small",
            onClick: function onClick() {
              return _this2.props.callback({ mode: modes.menuShowing, button: 'back' });
            },
            icon: React.createElement(DiIconbackArrow, null) })
        ),
        React.createElement("div", { className: "right parts" })
      ),
      this.props.mode == modes.noFaceDetected && React.createElement(
        "div",
        { className: "noFaceDetectedOverlay" },
        React.createElement(
          "div",
          { className: "text bold" },
          "No face detected"
        ),
        React.createElement(
          "div",
          { className: "text" },
          "Try again!"
        ),
        React.createElement(DiButton, {
          onClick: function onClick() {
            return _this2.props.callback({ mode: modes.takingPhoto, button: 'retake' });
          },
          className: 'red',
          text: "okay" })
      ),
      modes.confirmPhoto == this.props.mode && React.createElement(
        "div",
        { className: "menuButtons", style: { bottom: menuButtonsBottom } },
        React.createElement(DiIcon, {
          className: "",
          onClick: function onClick() {
            return _this2.props.callback({ mode: modes.takingPhoto });
          },
          text: 'retake',
          icon: React.createElement(DiIconCamera, null) }),
        React.createElement(DiIcon, {
          className: "",
          onClick: function onClick() {
            return _this2.props.callback({ mode: modes.photoCanvasShowing, updateImage: true, setBefore: true, button: 'use' });
          },
          text: 'use',
          icon: React.createElement(DiIconTick, null) })
      ),

      // false &&
      [modes.videoShowing, modes.canvasShowing, modes.photoCanvasShowing, modes.modelCanvasShowing].indexOf(this.props.mode) >= 0 && React.createElement(
        "div",
        { className: "menuButtons", style: { bottom: menuButtonsBottom } },
        React.createElement(DiIcon, {
          className: "",
          onClick: function () {
            this.props.callback({ mode: modes.menuShowing, button: 'switch' });
          }.bind(this),
          text: 'Switch',
          icon: React.createElement(DiIconSwitch, null) }),
        React.createElement(DiIcon, {
          className: "remove",
          onClick: function () {
            this.props.callback({ clearAll: Math.random() });
          }.bind(this),
          text: 'Remove',
          icon: React.createElement(DiIconClear, null) })
      )
    );
  };

  return DiViewerMenuBar;
}(Component);

export { DiViewerMenuBar as default };